import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=47050ca6"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports